import { cache_app_requests, cache_chunk_requests, useWorkerToProcessRequestsData } from "../config.js";
import { IS_BROWSER } from "../consts.js";
import { AppHttpWorkerService, AppIndexedDBWorkerService, AppThroughWebWorkerService, IndexedDBAppService, IndexedDBAppServiceForWorker } from "./IndexedDB/IndexedDBAppService.js";
import { IndexedDBChunkService } from "./IndexedDB/IndexedDBChunkService.js";
import { appsConf } from "./IndexedDB/appDataConf.js";
import { chunksConf } from "./IndexedDB/chunkDataConf.js";
import { AppHttpService } from "./httpService/AppHttpService.js";
import { ChunkHttpService } from "./httpService/ChunkHttpService.js";


// import "./IndexedDB/init.js";


//TODO confs should be used only for appropriate classes therefore it doesnt make sense to export them here

let AppDataService;
let ChunkDataService;

let appDataServiceConf;
let chunkDataServiceConf;

if (
    IS_BROWSER &&
    cache_app_requests &&
    !useWorkerToProcessRequestsData
) {
    AppDataService = IndexedDBAppService;
    appDataServiceConf = appsConf;
}


if (
    IS_BROWSER &&
    useWorkerToProcessRequestsData &&
    !cache_app_requests
) {
    AppDataService = AppThroughWebWorkerService;
    appDataServiceConf = appsConf; // todo seems isnt required for picked class
}


if (
    !IS_BROWSER
) {
    AppDataService = AppHttpService;
}


if (
    useWorkerToProcessRequestsData &&
    cache_app_requests
) {
    throw new Error;
    // not implemented
}


if (
    IS_BROWSER &&
    cache_chunk_requests &&
    !useWorkerToProcessRequestsData
) {
    ChunkDataService = IndexedDBChunkService;
    chunkDataServiceConf = chunksConf;
}

if (
    IS_BROWSER &&
    cache_chunk_requests &&
    useWorkerToProcessRequestsData
) {
    // here should be http instead, but should be revised variable ChunkDataService usage
    ChunkDataService = IndexedDBChunkService;
    chunkDataServiceConf = chunksConf;
}


if (
    !IS_BROWSER
) {
    ChunkDataService = ChunkHttpService;
}


let AppDataServiceForWorker = AppHttpWorkerService;
let ChunkDataServiceForWorker = IndexedDBChunkService;


if (
    useWorkerToProcessRequestsData &&
    !cache_app_requests
) {
    AppDataServiceForWorker = AppHttpWorkerService;
}

export {
    AppDataService,
    ChunkDataService,
    appDataServiceConf,
    chunkDataServiceConf,
    AppDataServiceForWorker,
    ChunkDataServiceForWorker,
};